import React, {Component} from 'react'
import ErrorWithHtmlParser from '../../pages/ErrorWithHtmlParser'
import Loading from '../../pages/Loading'
import {getActiveMaintenancePeriods} from '../../../services/vu'

class CheckForMaintenance extends Component {
  constructor (props) {
    super(props)

    this.state = {
      loadingMaintenancePeriods: true,
      isClosedForMaintenance: false,
      maintenancePeriod: {
        title: '',
        description: '',
      },
    }
  }

  componentDidMount() {
    getActiveMaintenancePeriods().then((maintenancePeriods = []) => {
      this.setState({
        loadingMaintenancePeriods: false
      })

      if (maintenancePeriods.length > 0) {
        let endTime = maintenancePeriods[0].attributes.dateRange.endValue
        let startTime = maintenancePeriods[0].attributes.dateRange.value
        let currentTime = Math.floor(new Date().getTime() / 1000)

        this.setState({
          isClosedForMaintenance: endTime > currentTime && (currentTime > startTime || currentTime == startTime),
          maintenancePeriod: {
            title: maintenancePeriods[0].attributes.title,
            description: maintenancePeriods[0].attributes.body.value,
          }
        })
      }
    })
  }

  render() {
    if (this.state.loadingMaintenancePeriods) {
      return <Loading/>
    }

    if (this.state.isClosedForMaintenance) {
      return <ErrorWithHtmlParser
        className="page__error--maintenance"
        title={this.state.maintenancePeriod.title}
        longDescription={this.state.maintenancePeriod.description}
        hideContactInfo={true}
      />
    }

    return this.props.children
  }
}

export default CheckForMaintenance
